export * from './public';

export const OFFERED_INSURANCES_IN_CMF = ['ASTONL162'];

export const EVENTS = {
  CLEAR: 'CLEAR',
  GO_TO_PAYMENT: 'GO_TO_PAYMENT',
};

export const eventRequestHandler = {
  execute() {},
  onExecute() {},
  stopOnExecute() {},
};
